import React from "react";
import InformationCard from "../../InformationCard";
import { editIcon, personRoundedIcon } from "../../../Icons/Icons";

const EmployeeSettings = () => {
  const settings = [
    {
      section: [
        {
          row: [
            { label: "Employee ID", data: "#1211" },
            { label: "Email", data: "suchetam@gmail.com" }
          ]
        },
        {
          row: [
            { label: "Title", data: "Mrs." },
            { label: "Phone Number", data: "+91 5600 500 600" }
          ]
        },
        {
          row: [
            { label: "Full Name", data: "Jane Cooper" },
            { label: "Work Phone", data: "+91 5600 500 600" }
          ]
        },
        {
          row: [
            { label: "Gender", data: "Female" },
            { label: "Company Email", data: "suchet555@ivhsr.com" }
          ]
        }
      ]
    }
  ];
  const loginActivity = [
    {
      section: [
        {
          row: [
            { label: "Employee ID", data: "#1211" },
            { label: "Email", data: "suchetam@gmail.com" }
          ]
        },
        {
          row: [
            { label: "Title", data: "Mrs." },
            { label: "Phone Number", data: "+91 5600 500 600" }
          ]
        },
        {
          row: [
            { label: "Full Name", data: "Jane Cooper" },
            { label: "Work Phone", data: "+91 5600 500 600" }
          ]
        },
        {
          row: [
            { label: "Gender", data: "Female" },
            { label: "Company Email", data: "suchet555@ivhsr.com" }
          ]
        }
      ]
    }
  ];
  return (
    <div className="general-information-div mb-7">
      <InformationCard
        title="Settings"
        layout="table"
        titleIcon={personRoundedIcon}
        rows={settings}
      />
      <InformationCard
        title="Login Activity"
        layout="table"
        titleIcon={personRoundedIcon}
        rows={loginActivity}
      />
    </div>
  );
};

export default EmployeeSettings;
